import apiClient from "./ApiService";
import { PATH_NEIGHBORHOODS } from "../config/env";

export const getNeighborhoods = async()=>{
    return await apiClient.get(PATH_NEIGHBORHOODS);
}
export default getNeighborhoods;